import { render, staticRenderFns } from "./BillingRecord.vue?vue&type=template&id=2466d504&scoped=true&"
import script from "./BillingRecord.vue?vue&type=script&lang=js&"
export * from "./BillingRecord.vue?vue&type=script&lang=js&"
import style0 from "./BillingRecord.vue?vue&type=style&index=0&id=2466d504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466d504",
  null
  
)

export default component.exports